import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "500px",
    borderRadius: "16px",
    opacity: 0.8
};

const MapLocationComponent = ({ lat, lng }) => {
    const center = {
        lat: lat,
        lng: lng,
    };
    return (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={18}>
            <Marker position={center} />
        </GoogleMap>
    );
};

export default MapLocationComponent;
